import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { isValidCron } from 'cron-validator';
import cronstrue from 'cronstrue';
import { MessageService } from 'primeng/api';
import { SharedComponents } from '../../../components/shared.module';
import { ProjectService } from '../../../core/services/project/project.service';
import { RestService } from '../../../core/services/rest.service';
import { ToasterService } from '../../../core/services/toaster-service';
import { MaterialModule } from '../../../core/shared/material.module';
import { MessageEnum } from '../../../core/utils/message.enum';
@Component({
  selector: 'app-add-schedule',
  standalone: true,
   imports: [ SharedComponents, CommonModule, MaterialModule,MatIconModule],
  templateUrl: './add-schedule.component.html',
  styleUrl: './add-schedule.component.scss'
})
export class AddScheduleComponent implements OnInit{
  @Input()
      data: { title?: string, id?:string} = {};
  activeModal = inject(NgbActiveModal);
  plans:any = [];
  scheduleName:string="";
  searchPlan:string="";
  searchSelectedPlan:string ="";
  projectId: any ='';
  automationProjectId: any ='';
  isDataLoaded: boolean= false;
  private messageService = inject(MessageService);
  selectedPlans:any =[];
  selectedPlan:any=null;
  planIndexToRemove:any=-1;
  planSearchResults:any= [];
  selectedPlansSearchResults:any=[];
  cronExpression:string ="";
  cronError:string = "";
  cronDescription:string = "";
  isCronValid: boolean = false;
  isActive: boolean = false;

  constructor(
      private restService : RestService,
      private projectService: ProjectService,
      private readonly toaster: ToasterService
    ){
      this.projectService.getProjectId().subscribe((id) => {
        this.projectId = id;
      });
      this.projectService.getAutomationProjectId().subscribe((id: any) => {
        this.automationProjectId = id;
      });
    }

  ngOnInit(){
    this.fetchPlans();
  }

  fetchPlans(){
    this.restService.getTestPlans(this.projectId,this.automationProjectId).subscribe((response)=>{
      let data = response.data;
      let row;
      this.plans = [];
      for(let i=0;i<data.length;i++){
        row= data[i];
        this.plans = [...this.plans,{
          id:row.id,
          name: row.name,
          testScripts:row.testScripts
        }];
      }
      
      this.planSearchResults = [...this.plans];
      if(this.data.id){
        this.getSelectedPlansById(this.data.id);
      }else{
        this.isDataLoaded= true;
      }
      
    },(error)=>{
      this.toaster.pop({ type: 'error', text: MessageEnum.TEST_PLAN_LOAD_FAILURE });
      this.isDataLoaded= true;
    });
  }

  getSelectedPlansById(id:string){
    this.restService.getPlansByScheduleId(this.projectId,this.automationProjectId, id).subscribe((response)=>{
      this.isDataLoaded= true;
      let data = response.data;  
      let plans = data.plans;
      this.searchSelectedPlan = "";
      this.selectedPlansSearchResults = [];
      this.scheduleName = data.name;
      this.cronExpression = data?.cron;
      this.validateCron();
      plans.forEach((plan:any)=>{
        this.selectedPlans = [...this.selectedPlans,{
          id:plan.testPlanId,
          name: plan.testPlanName,
          testScripts:plan.executionScripts
        }];
        this.selectedPlansSearchResults = [...this.selectedPlans];
      });    
    },(error)=>{
      this.isDataLoaded= true;
      this.toaster.pop({ type: 'error', text: MessageEnum.TEST_PLAN_LOAD_FAILURE });
    });
  }

  closePopup(){
    this.activeModal.dismiss('Cross click');
  }

  saveSchedule(){
    let payload:any = {
      name:this.scheduleName,
      cron:this.cronExpression,
      plans:[]
    }
    this.selectedPlans.forEach((plan:any)=>{
      let curPlan:any = {
        testPlanId: plan.id,
        testPlanName: plan.name,
        executionScripts: []
      }
      plan.testScripts.forEach((script:any)=>{
        let curScript:any = {
          sequence: script.sequence,
          id: script.id,
          agentId: script.agentId,
          browser: script.browser
        }
        if(!script.agentId){
          curScript.agentId = null;
          curScript.agentType = 'CLUSTER';
        }
        curPlan.executionScripts.push(curScript);
        
      })
      payload.plans.push(curPlan);
    });
    if(this.data.id){
      this.restService.updateScheduleById(this.projectId,this.automationProjectId,payload, this.data.id).subscribe((response)=> {
        this.toaster.pop({ type: 'success', text: MessageEnum.SCHEDULE_UPDATE_SUCCESS });
        this.activeModal.close('refresh');
      },(error)=> {
        this.toaster.pop({ type: 'error', text: MessageEnum.SCHEDULE_UPDATE_FAILURE });
        this.isDataLoaded= true;
      });
    }else{
      this.restService.addNewSchedule(this.projectId,this.automationProjectId,payload).subscribe((response)=> {
        this.toaster.pop({ type: 'success', text: MessageEnum.SCHEDULE_CREATE_SUCCESS });
        this.activeModal.close('refresh');
      },(error)=>{
        this.toaster.pop({ type: 'error', text: MessageEnum.SCHEDULE_CREATE_FAILURE });
      });
    }
  }
  modifyPlansList(){
    let key = this.searchPlan.toLowerCase();
    this.planSearchResults= this.plans.filter((plan:any)=> plan.name.toLowerCase().includes(key));
  }
  modifySelectedList(){
    let key = this.searchSelectedPlan.toLowerCase();
    this.selectedPlansSearchResults= this.selectedPlans.filter((plan:any)=> plan.name.toLowerCase().includes(key));
  }

  updateSelected(plan:any){
    this.selectedPlan = this.selectedPlan?.id == plan.id ? null: plan;
  }

  updatePlanToRemove(index:any){
    this.planIndexToRemove = this.planIndexToRemove == index ? -1: index;
  }

  moveSelected(type?:string){
    if(type && this.planIndexToRemove>-1){
      this.selectedPlans.splice(this.planIndexToRemove,1);
      this.planIndexToRemove = -1;
    }else{
      this.selectedPlans.push(this.selectedPlan);
      this.selectedPlan = null;
    }
    this.searchSelectedPlan = "";
    this.selectedPlansSearchResults = [...this.selectedPlans];
  }

  validateCron() {
    if (!isValidCron(this.cronExpression, { seconds: true })) {
      this.cronError = 'Invalid cron expression';
      this.cronDescription = '';
      this.isCronValid = false;
    } else {
      this.cronError = '';
      this.cronDescription = cronstrue.toString(this.cronExpression, { use24HourTimeFormat: true });
      this.isCronValid = true;
    }
  }
  
  
}
